import React from "react";

import { Pagination as WfpPagination } from "@wfp/ui";
import { FormattedMessage, useIntl } from "react-intl";

const Pagination = (props) => {
  const intl = useIntl();
  return (
    <WfpPagination
      backwardText={intl.formatMessage({
        id: "pagination.backwardText",
        defaultMessage: "Backwards",
      })}
      forwardText={intl.formatMessage({
        id: "pagination.forwardText",
        defaultMessage: "Forwards",
      })}
      itemsPerPageText={intl.formatMessage({
        id: "pagination.itemPerPage",
        defaultMessage: "Items per page",
      })}
      pageNumberText={intl.formatMessage({
        id: "pagination.pageNumber",
        defaultMessage: "Page number",
      })}
      itemRangeText={(min, max, total) => (
        <FormattedMessage
          id="pagination.itemsNumber"
          defaultMessage="{min} to {max} of {total} items"
          values={{
            min,
            max,
            total,
          }}
        />
      )}
      pageRangeText={(current, total) => (
        <FormattedMessage
          id="pagination.pagesNumber"
          defaultMessage="{current} of {total} pages"
          values={{
            current,
            total,
          }}
        />
      )}
      {...props}
    />
  );
};

export default Pagination;
